// ##### Komarov 2025-07-12
import React, { useEffect, useState } from 'react';
// ##### 22-11-08 Komarov
import { CaretUpOutlined } from '@ant-design/icons';
// ##### Komarov 2025-07-25
// import './ScrollToTopButtonCSS.css';

let effectNumber = 0;
const componentName = 'ScrollToTopButton';

// ##### Komarov 2025-07-14
const ScrollToTopButton = () => {
  const [scrollButtonVisible, setScrollButtonVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrollButtonVisible(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const buttonClass = scrollButtonVisible ? 'totopbutton' : 'notvisible';

  return (
    <button
      data-component="ScrollToTopButton"
      type="button"
      className={buttonClass}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <CaretUpOutlined style={{ color: 'white' }} />
    </button>
  );
};

// ##### 25-05-21 Komarov
export default ScrollToTopButton;
